import React from 'react'
import './style.css'

function Tripi(props) {

    const { size } = props

    const svgSide = size * 1.2
    const svgSize = svgSide + 'px'
    const svgMid = svgSide / 2  

    const trans = (x) => {
        return {
            c: {
                x: x / 2,
                y: x / 3
            },
            l: {
                x: -x / 3,
                y: -x * 2 / 9
            },
            r: {
                x: x / 3,
                y: -x * 2 / 9
            },
            b: {
                x: 0,
                y: x * 21 / 54
            },
            radius: x / 3 * 0.8
        }
    }

    const trans27 = trans(size)
    const trans9 = trans(size / 3)
    const trans3 = trans(size / 9)
    const trans1 = trans(size / 27)

    return (
        <svg width={svgSize} height={svgSize}>
            <g fill='#61DAFB' transform={`translate(${svgMid}, ${svgMid})`}>
                <circle id='1' cx='0' cy='0' r={trans27.radius} />
                <g className='rotate'>
                    <g transform={'translate(' + trans27.l.x + ',' + trans27.l.y + ')'}>
                        <g className='rotate'>
                            <circle id='1l' cx='0' cy='0' r={trans9.radius} />
                            <g transform={'translate(' + trans9.l.x + ',' + trans9.l.y + ')'}>
                                <g className='rotate'>
                                    <circle id='1ll' cx='0' cy='0' r={trans3.radius} />
                                    <circle id='1lll' cx={trans3.l.x} cy={trans3.l.y} r={trans1.radius} />
                                    <circle id='1llr' cx={trans3.r.x} cy={trans3.r.y} r={trans1.radius} />
                                    <circle id='1llc' cx={trans3.b.x} cy={trans3.b.y} r={trans1.radius} />
                                </g>
                            </g>
                            <g transform={'translate(' + trans9.r.x + ',' + trans9.r.y + ')'}>
                                <g className='rotate'>
                                    <circle id='1lr' cx='0' cy='0' r={trans3.radius} />
                                    <circle id='1lrl' cx={trans3.l.x} cy={trans3.l.y} r={trans1.radius} />
                                    <circle id='1lrr' cx={trans3.r.x} cy={trans3.r.y} r={trans1.radius} />
                                    <circle id='1lrc' cx={trans3.b.x} cy={trans3.b.y} r={trans1.radius} />
                                </g>
                            </g>
                            <g transform={'translate(' + trans9.b.x + ',' + trans9.b.y + ')'}>
                                <g className='rotate'>
                                    <circle id='1lb' cx='0' cy='0' r={trans3.radius} />
                                    <circle id='1lbl' cx={trans3.l.x} cy={trans3.l.y} r={trans1.radius} />
                                    <circle id='1lbr' cx={trans3.r.x} cy={trans3.r.y} r={trans1.radius} />
                                    <circle id='1lbc' cx={trans3.b.x} cy={trans3.b.y} r={trans1.radius} />
                                </g>
                            </g>
                        </g>
                    </g>
                    <g transform={'translate(' + trans27.r.x + ',' + trans27.r.y + ')'}>
                        <g className='rotate'>
                            <circle id='1r' cx='0' cy='0' r={trans9.radius} />
                            <g transform={'translate(' + trans9.l.x + ',' + trans9.l.y + ')'}>
                                <g className='rotate'>
                                    <circle id='1rl' cx='0' cy='0' r={trans3.radius} />
                                    <circle id='1rll' cx={trans3.l.x} cy={trans3.l.y} r={trans1.radius} />
                                    <circle id='1rlr' cx={trans3.r.x} cy={trans3.r.y} r={trans1.radius} />
                                    <circle id='1rlc' cx={trans3.b.x} cy={trans3.b.y} r={trans1.radius} />
                                </g>
                            </g>
                            <g transform={'translate(' + trans9.r.x + ',' + trans9.r.y + ')'}>
                                <g className='rotate'>
                                    <circle id='1rr' cx='0' cy='0' r={trans3.radius} />
                                    <circle id='1rrl' cx={trans3.l.x} cy={trans3.l.y} r={trans1.radius} />
                                    <circle id='1rrr' cx={trans3.r.x} cy={trans3.r.y} r={trans1.radius} />
                                    <circle id='1rrc' cx={trans3.b.x} cy={trans3.b.y} r={trans1.radius} />
                                </g>
                            </g>
                            <g transform={'translate(' + trans9.b.x + ',' + trans9.b.y + ')'}>
                                <g className='rotate'>
                                    <circle id='1rb' cx='0' cy='0' r={trans3.radius} />
                                    <circle id='1rbl' cx={trans3.l.x} cy={trans3.l.y} r={trans1.radius} />
                                    <circle id='1rbr' cx={trans3.r.x} cy={trans3.r.y} r={trans1.radius} />
                                    <circle id='1rbc' cx={trans3.b.x} cy={trans3.b.y} r={trans1.radius} />
                                </g>
                            </g>
                        </g>
                    </g>
                    <g transform={'translate(' + trans27.b.x + ',' + trans27.b.y + ')'}>
                        <g className='rotate'>
                            <circle id='1b' cx='0' cy='0' r={trans9.radius} />
                            <g transform={'translate(' + trans9.l.x + ',' + trans9.l.y + ')'}>
                                <g className='rotate'>
                                    <circle id='1bl' cx='0' cy='0' r={trans3.radius} />
                                    <circle id='1bll' cx={trans3.l.x} cy={trans3.l.y} r={trans1.radius} />
                                    <circle id='1blr' cx={trans3.r.x} cy={trans3.r.y} r={trans1.radius} />
                                    <circle id='1blc' cx={trans3.b.x} cy={trans3.b.y} r={trans1.radius} />
                                </g>
                            </g>
                            <g transform={'translate(' + trans9.r.x + ',' + trans9.r.y + ')'}>
                                <g className='rotate'>
                                    <circle id='1br' cx='0' cy='0' r={trans3.radius} />
                                    <circle id='1brl' cx={trans3.l.x} cy={trans3.l.y} r={trans1.radius} />
                                    <circle id='1brr' cx={trans3.r.x} cy={trans3.r.y} r={trans1.radius} />
                                    <circle id='1brc' cx={trans3.b.x} cy={trans3.b.y} r={trans1.radius} />
                                </g>
                            </g>
                            <g transform={'translate(' + trans9.b.x + ',' + trans9.b.y + ')'}>
                                <g className='rotate'>
                                    <circle id='1bb' cx='0' cy='0' r={trans3.radius} />
                                    <circle id='1bbl' cx={trans3.l.x} cy={trans3.l.y} r={trans1.radius} />
                                    <circle id='1bbr' cx={trans3.r.x} cy={trans3.r.y} r={trans1.radius} />
                                    <circle id='1bbc' cx={trans3.b.x} cy={trans3.b.y} r={trans1.radius} />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )

}

export default Tripi
